/**
 * Processes HTML content by extracting styles and removing head content
 */
export function processHtmlContent<T extends { body: string }>(result: T): T & { style: string; trackingIds: string[] } {
  const styleTweakRegex = /<style>(.*?)<\/style>/gs;
  const headContentRegex = /<head>.*?<\/head>/gs;
  const trackingIdRegex = /<[^>]*data-track-id="([^"]*)"[^>]*>/gs;
  // Extract style content (without the style tags themselves)
  const styleMatches = result?.body.match(styleTweakRegex);
  const styleContent = styleMatches?.[0]?.replace(/<\/?style[^>]*>/g, "") ?? "";

  // Remove head content from body
  const bodyWithoutHead = result.body.replace(headContentRegex, "");

  const trackingIds: string[] = [];
  let match;
  while ((match = trackingIdRegex.exec(bodyWithoutHead)) !== null) {
    trackingIds.push(match[1]);
  }
  return {
    ...result,
    body: bodyWithoutHead,
    style: styleContent,
    trackingIds,
  };
}

/**
 * @description Takes an array of AgentResponse results and processes each HTML body
 * to extract styles and clean up the content.
 * @param results - Array of results containing HTML content
 * @returns Array of results with processed HTML content and extracted styles
 * @template T - Type of the results, must have a body property of type string
 */
export function processHtmlResults<T extends { body: string }>(results: T[]): (T & { style: string; trackingIds: string[] })[] {
  return results.map(processHtmlContent);
}
